<template>
  <div class="container">
    <div class="main">
      <div class="left">
        <div class="item1">
          <span class="title">交易分类比重</span>
          <div id="leftItem1Echarts" style="height: 100%"></div>
        </div>
        <div class="item2">
          <span class="title">类别交易排行</span>
          <div id="leftItem2Echarts" style="height: 100%"></div>
        </div>
        <div class="item3">
          <span class="title">交易额走势</span>
          <div id="leftItem3Echarts" style="height: 100%"></div>
        </div>
      </div>
      <div class="center">
        <div class="mapPlaceholder"></div>
        <div class="item1">
          <span class="title">交易详情数据</span>
          <div class="centerItemContainer">
            <div
              class="centerItem"
              style="margin-top: 30px"
              v-for="(item, index) in center_item1_data"
              :key="index"
              v-show="index == 2 || index == 3"
            >
              <img class="centerItemImg" :src="item.img" alt="" />
              <span class="centerItemTitle">{{ item.title }}</span>
              <div class="centerItemContent">
                <span class="centerItemNumber">{{
                  item.decimals > 0
                    ? Number(item.number).toFixed(item.decimals)
                    : Math.floor(Number(item.number))
                }}</span>
                <span class="centerItemUnit">{{ item.unit }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="item1">
          <span class="title">交易地区排行</span>
          <div class="rightItem1DataContainer">
            <div
              class="rightItem1Data"
              v-for="(item, index) in right_item1_data"
              :key="index"
            >
              <div class="rightItem1DataImage" v-if="index < 3">
                <img
                  src="@/assets/bigData/first.png"
                  alt="1"
                  v-if="index == 0"
                />
                <img
                  src="@/assets/bigData/second.png"
                  alt="2"
                  v-if="index == 1"
                />
                <img
                  src="@/assets/bigData/third.png"
                  alt="3"
                  v-if="index == 2"
                />
              </div>
              <div class="rightItem1DataIndex" v-if="index > 2">
                {{ index + 1 }}
              </div>

              <div class="rightItem1DataName">
                {{ item.name }}
              </div>
              <div class="rightItem1DataShadow">
                <div
                  class="rightItem1DataLong"
                  :style="{
                    width:
                      (Number(item.value) /
                        Number(right_item1_data_max_number)) *
                        100 +
                      '%',
                  }"
                ></div>
              </div>
              <span class="rightItem1DataValue">
                {{ Number(item.value) }}
              </span>
            </div>
          </div>
        </div>
        <div class="item2">
          <span class="title">实时数据</span>
          <div class="rightItem2Container">
            <vue-seamless-scroll
              :class-option="{ step: 0.6 }"
              :data="right_item2_data"
              class="rightItem2Roll"
            >
              <ul class="rightItem2DataList">
                <li
                  class="rightItem2Data"
                  v-for="(item, index) in right_item2_data"
                  :key="index"
                >
                  <img src="@/assets/img/shishiImg.png" alt="" />
                  <span class="rightItem2DataNews">
                    {{
                      item.dept_name +
                      "交易市场，交易金额" +
                      item.deal_total +
                      "元"
                    }}
                  </span>
                </li>
              </ul>
            </vue-seamless-scroll>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { amountMon, tansDeptOrder, transData, transIndicator, transTypeAmount, transTypeRate, transIndicator2 } from "@/api/大数据.js"
import * as echarts from "echarts"
import vueSeamlessScroll from 'vue-seamless-scroll'
import CountTo from "vue-count-to"


export default {
  components: {
    CountTo,
    vueSeamlessScroll
  },
  props: {
    formDetail: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      duration: 1000,
      center_item1_data: [
        {
          title: "挂牌数量",
          number: "0",
          unit: "宗",
          img: require("@/assets/img/gpsl.png"),
          decimals: 0
        },
        {
          title: "挂牌金额",
          number: "0",
          unit: "万元",
          img: require("@/assets/img/gpje.png"),
          decimals: 2
        },
        {
          title: "成交数量",
          number: "0",
          unit: "宗",
          img: require("@/assets/img/cjsl.png"),
          decimals: 0
        },
        {
          title: "成交金额",
          number: "0",
          unit: "万元",
          img: require("@/assets/img/cjje.png"),
          decimals: 2
        },
        {
          title: "参与竞价人数",
          number: "0",
          unit: "人",
          img: require("@/assets/img/qqcyjjzrs.png"),
          decimals: 0
        }
      ],
      right_item1_data: [],
      right_item1_data_max_number: 0,
      right_item2_data: [],
      // 点击后设置的deptId
      deptId: null,

      numForm: {
        v1: 0,
        v2: 0,
        v3: 0,
        v4: 0,
        v5: 0,
        v6: 0,
        v7: 0,
        v8: 0,
        v9: 0,
        v10: 0,
        v11: 0,
        v12: 0,
        v13: 0,
        v14: 0,
      },
    }
  },

  beforeDestroy () {
  },
  mounted () {
    this.getNums()
  },
  watch: {

  },
  methods: {
    // 地图点击调用事件
    getNums () {
      console.log('cwgl', this.formDetail)

      this.$nextTick(() => {
        console.log('cqjy', this.formDetail)
        let deptId = this.formDetail.deptId
        this.deptId = deptId

        this.leftItem1Load(deptId)
        this.leftItem2Load(deptId)
        this.leftItem3Load(deptId)
        this.centerItem1Load(deptId)
        this.rightItem1Load(deptId)
        this.rightItem2Load(deptId)
        this.getTransIndicator2(deptId)
      })
    },
    // 获取百分比
    getPercentage (name, data) {
      let dataTotal = 0
      data.forEach(item => {
        dataTotal += Number(item.value)
      })
      let checkData = data.find(item => item.name == name)
      return checkData && dataTotal ? (Number(checkData.value) / Number(dataTotal) * 100).toFixed(2) + "%" : "0%"
    },
    leftItem1Load (deptId) {
      let data = { deptId, top: 15 }
      transTypeRate(data, deptId).then(res => {
        let data = res.data.data
        var chartDom = document.getElementById('leftItem1Echarts')
        var myChart = echarts.init(chartDom)
        var option
        option = {
          tooltip: {
            trigger: 'item',
            formatter: '{b}:{c}笔'
          },
          color: ["#126DFF", "#35D4AB", "#FFA500", "#19A9FF", "#FF7C84"],
          legend: {
            orient: 'vertical',
            type: 'scroll',
            right: '0',
            top: '20%',
            itemWidth: 5,
            itemHeight: 5,
            borderRadius: 10,
            formatter: (name) => {
              return (name.length > 10 ? name.slice(0, 10) + "\n" + name.slice(10) : name) + " " + this.getPercentage(name, data)
            },
            textStyle: {
              fontSize: 14,
              color: "#ffffff",
              padding: [0, 0, -10, 0],
            },
            itemGap: 16,
            pageTextStyle: {
              color: "#ffffff",
            },
            pageIconColor: "#ffffff",
          },
          series: [
            {
              type: 'pie',
              radius: [30, 60],
              avoidLabelOverlap: false,
              center: ['30%', '48%'],
              label: {
                show: true,
                position: 'center',
                formatter: "交易分类",
                color: "#ffffff",
                fontSize: 12
              },
              emphasis: {
                label: {
                  show: false,
                  fontSize: 16,
                  fontWeight: 'bold'
                }
              },
              labelLine: {
                show: true
              },
              data: data,
            }
          ]
        }
        option && myChart.setOption(option)
      })

    },
    leftItem2Load (deptId) {
      let data = { deptId, top: 12 }
      transTypeAmount(data, deptId).then(res => {
        console.log("transTypeAmount", res)
        let data = res.data.data.data
        let xAlias = res.data.data.xAlias
        var chartDom = document.getElementById('leftItem2Echarts')
        var myChart = echarts.init(chartDom)
        var option
        option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            },
            formatter: '{b}:{c}元'
          },
          dataZoom: [
            {
              // start: 0,//默认为0
              // end: 100,//默认为100
              type: 'slider',
              show: true,
              // xAxisIndex: [0],
              handleSize: 0,//滑动条的 左右2个滑动条的大小
              startValue: 0, // 初始显示值
              endValue: 8, // 结束显示值
              height: 0,//组件高度
              left: '5%', //左边的距离
              right: '4%',//右边的距离
              bottom: 0,//底边的距离
              borderColor: "#3D85FE",
              fillerColor: '#fff',
              borderRadius: 8,
              backgroundColor: '#00000016',//两边未选中的滑动条区域的颜色
              showDataShadow: false,//是否显示数据阴影 默认auto
              showDetail: false,//即拖拽时候是否显示详细数值信息 默认true
              realtime: true, //是否实时更新
              filterMode: 'filter',
            },
            //下面这个属性是里面拖到
            {
              type: 'inside',
              show: true,
              // xAxisIndex: [0],
              start: 1,//默认为1
              end: 100,//默认为100
            },
          ],
          grid: {
            left: '10',
            right: '30',
            bottom: '10',
            top: "40",
            containLabel: true
          },
          legend: {
            show: true,
            textStyle: {
              color: '#fff'
            }
          },
          xAxis: [
            {
              type: 'category',
              data: xAlias,
              axisTick: {
                alignWithLabel: true
              },
              axisLabel: {
                interval: 0,
                formatter: function (value) {
                  return value.length > 5 ? value.slice(0, 5) + "\n" + value.slice(5, value.length) : value
                },
                fontSize: 12,
                color: "#fff",
              },
              axisLine: {
                lineStyle: {
                  color: "#fff"
                }
              },
            }
          ],
          yAxis: [
            {
              type: 'value',
              axisLine: {
                show: true // 这里设置为false，不显示y轴线
              },
              name: "元",
              nameTextStyle: {
                color: "#fff",
              },
              axisLabel: {
                color: "#fff",
              },
              splitLine: {
                show: false
              }
            }
          ],
          series: [
            {
              name: '交易额',
              type: 'bar',
              barWidth: '30%',
              data: data,
              itemStyle: {
                color: "#126DFF"
              }
            }
          ]
        }
        option && myChart.setOption(option)
      })
    },
    leftItem3Load (deptId) {
      let data = { deptId }
      amountMon(data, deptId).then(res => {
        console.log("amountMon", res)
        let data = res.data.data.data
        let xAlias = res.data.data.xAlias
        var chartDom = document.getElementById('leftItem3Echarts')
        var myChart = echarts.init(chartDom)
        var option
        option = {
          dataZoom: [
            {
              // start: 0,//默认为0
              // end: 100,//默认为100
              type: 'slider',
              show: true,
              // xAxisIndex: [0],
              handleSize: 0,//滑动条的 左右2个滑动条的大小
              startValue: 0, // 初始显示值
              endValue: 8, // 结束显示值
              height: 0,//组件高度
              left: '5%', //左边的距离
              right: '4%',//右边的距离
              bottom: 0,//底边的距离
              borderColor: "#3D85FE",
              fillerColor: '#fff',
              borderRadius: 8,
              backgroundColor: '#00000016',//两边未选中的滑动条区域的颜色
              showDataShadow: false,//是否显示数据阴影 默认auto
              showDetail: false,//即拖拽时候是否显示详细数值信息 默认true
              realtime: true, //是否实时更新
              filterMode: 'filter',
            },
            //下面这个属性是里面拖到
            {
              type: 'inside',
              show: true,
              // xAxisIndex: [0],
              start: 1,//默认为1
              end: 100,//默认为100
            },
          ],
          grid: {
            left: '10',
            right: '30',
            bottom: '10',
            top: "40",
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: xAlias,
            axisLabel: {
              formatter: function (value) {
                return value
              },
              fontSize: 14,
              color: "#fff",
            },
            axisLine: {
              show: false
            },
          },
          yAxis: {
            type: 'value',
            name: "元",
            axisLine: {
              show: true // 这里设置为false，不显示y轴线
            },
            nameTextStyle: {
              color: "#fff",
            },
            axisLabel: {
              color: "#fff",
            },
            splitLine: {
              show: false
            }
          },
          tooltip: {
            trigger: 'axis',
            formatter: '{b}<br />交易额:{c}元'
          },
          legend: {
            show: true,
            textStyle: {
              color: '#fff'
            }
          },
          series: [
            {
              name: "交易额",
              data: data,
              type: 'line',
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#4A9DFF" },
                  { offset: 0.8, color: "#DAEBFF" },
                  { offset: 1, color: "#ffffff" },
                ]), // 区域填充颜色，带有半透明效果
              },
              lineStyle: {
                color: "#2187FF"
              },
              itemStyle: {
                color: "#2187FF"
              },
            }
          ]
        }

        option && myChart.setOption(option)
      })
    },
    centerItem1Load (deptId) {
      transIndicator({ deptId }, deptId).then(res => {
        console.log("transIndicator", res.data.data)
        this.center_item1_data = this.center_item1_data.map((item, index) => {
          if (item.unit.indexOf("万") >= 0) {
            res.data.data[(index + 1).toString()] = (Number(res.data.data[(index + 1).toString()]) / 10000).toFixed(item.decimals)
          }
          return {
            ...item,
            number: res.data.data[(index + 1).toString()]
          }
        })
        console.log("center_item1_data", this.center_item1_data)
      })
    },
    rightItem1Load (deptId) {
      tansDeptOrder({ deptId }, deptId).then(res => {
        this.right_item1_data = res.data.data
        let maxVal = this.right_item1_data.length > 0 && this.right_item1_data[0].value
        this.right_item1_data.forEach(item => {
          maxVal = Number(item.value) > Number(maxVal) ? Number(item.value) : Number(maxVal)
        })
        this.right_item1_data_max_number = (Number(maxVal) * 1.1 + 1).toFixed(0)
      })
    },
    rightItem2Load (deptId) {
      transData({ deptId }, deptId).then(res => {
        this.right_item2_data = res.data.data
      })
    },
    // 获取指标
    getTransIndicator2 (deptId) {
      transIndicator2({ deptId }, deptId).then(res => {
        this.numForm = res.data.data
      })
    },
  },
}
</script>
<style>
::-webkit-scrollbar {
  display: none;
}
</style>
<style scoped lang="scss">
#leftItem1Echarts > div {
  width: 100% !important;
  height: 100% !important;
}
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
.container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;

  .main {
    display: flex;
    flex-flow: row nowrap;
    width: 100%;
    height: 100%;

    .left {
      display: flex;
      flex-flow: column nowrap;
      width: 562px;
      height: 100%;

      & > div {
        flex: 1;
        width: 100%;
        display: flex;
        flex-flow: column nowrap;
        background: url("../../../assets/img/jyflbz.png") no-repeat;
        background-size: 100% 100%;
        padding: 20px 30px 20px;
        margin-bottom: 12px;

        &:last-child {
          margin-bottom: 0;
        }

        & > div {
          height: 100%;
          width: 100%;
        }

        & > .title {
          font-family: Source Han Sans CN;
          font-weight: bold;
          font-size: 24px;
          color: #28f7ff;
          text-align: center;
        }
      }
    }

    .center {
      display: flex;
      flex-flow: column nowrap;
      flex: 1;
      height: 100%;
      margin: 0 32px;

      .mapPlaceholder {
        flex: 2;
        width: 100%;
      }

      .item1 {
        height: 267px;
        width: 100%;
        display: flex;
        flex-flow: column nowrap;
        background: url("../../../assets/img/jyflbz.png") no-repeat;
        background-size: 100% 100%;
        padding: 20px 0 34px 0;

        & > .title {
          font-family: Source Han Sans CN;
          font-weight: bold;
          font-size: 24px;
          color: #28f7ff;
          text-align: center;
        }

        .centerItemContainer {
          width: 100%;
          flex: 1;
          display: flex;
          flex-flow: row nowrap;
          align-items: center;
          margin-top: 10px;
          box-sizing: border-box;
          padding: 0 40px 0 40px;

          .centerItem {
            flex: 0.8;
            height: 100%;
            display: flex;
            flex-flow: column nowrap;
            align-items: center;

            /* &:last-child>.centerItemTitle {
                font-size: 11px;
              } */

            .centerItemImg {
              width: 60px;
              height: auto;
            }

            .centerItemTitle {
              font-family: MicrosoftYaHei;
              color: #fff;
              font-weight: 400;
              font-size: 18px;
              text-align: center;
              line-height: 18px;
              display: block;
              margin: 10px 0;
            }

            .centerItemContent {
              display: flex;
              align-items: flex-end;
              flex-flow: row nowrap;

              .centerItemNumber {
                font-family: MicrosoftYaHeiUI;
                color: #fff;
                font-weight: 600;
                font-size: 20px;
                margin-right: 2px;
                white-space: nowrap;
              }

              .centerItemUnit {
                font-family: MicrosoftYaHeiUI;
                color: #fff;
                font-size: 14px;
                white-space: nowrap;
              }
            }

            .centerText {
              width: 100%;
              height: auto;
              text-indent: 2em;
              color: #fff;
              font-size: 14px;
              line-height: 20px;

              .cRed {
                color: red;
                font-size: 16px;
              }
            }
          }
        }
      }
    }

    .right {
      display: flex;
      flex-flow: column nowrap;
      width: 562px;
      height: 100%;

      .item1 {
        flex: 1;
        max-height: 100%;
        width: 100%;
        background: url("../../../assets/img/jydqph.png") no-repeat;
        background-size: 100% 100%;

        .rightItem1DataContainer {
          max-height: 446px;
          width: 100%;
          padding: 10px 20px;
          padding-bottom: 0;
          overflow: auto;

          .rightItem1Data {
            height: 40px;
            width: 100%;
            display: flex;
            flex-flow: row nowrap;
            align-items: center;

            .rightItem1DataImage {
              width: 30px;
              height: 100%;
              display: flex;
              flex-flow: row nowrap;
              align-items: center;
              justify-content: center;

              img {
                width: 18px;
                height: auto;
              }
            }

            .rightItem1DataIndex {
              width: 30px;
              height: 100%;
              line-height: 40px;
              text-align: center;
              font-size: 14px;
              color: #fff;
            }

            .rightItem1DataName {
              color: #fff;
              font-size: 14px;
              width: 130px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              text-align: center;
            }

            .rightItem1DataShadow {
              flex: 1;
              border: 1px solid #fff;
              height: 12px;
              border-radius: 200px;
              padding: 1px;
              background-color: #fff;

              .rightItem1DataLong {
                height: 100%;
                border-radius: 200px;
                background-color: #3d85fe;
              }
            }

            .rightItem1DataValue {
              width: 50px;
              font-size: 14px;
              color: #fff;
              text-align: center;
            }
          }
        }
      }

      .item2 {
        width: 100%;
        height: 267px;
        box-sizing: border-box;
        background: url("../../../assets/img/jyflbz.png") no-repeat;
        background-size: 100% 100%;
        padding-right: 20px;

        .rightItem2Container {
          width: 100%;
          max-height: calc(100% - 24px);

          .rightItem2Roll {
            overflow: hidden;
            height: 100%;
            width: 100%;

            .rightItem2DataList {
              display: flex;
              flex-flow: column nowrap;
              padding-left: 40px;

              .rightItem2Data {
                width: 100%;
                display: flex;
                flex-flow: row nowrap;
                padding: 6px 0;
                align-items: center;

                img {
                  width: 12px;
                  height: auto;
                }

                .rightItem2DataNews {
                  color: #fff;
                  margin-left: 4px;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
              }
            }
          }
        }
      }

      & > div {
        width: 100%;
        display: flex;
        flex-flow: column nowrap;
        padding: 20px 0 34px;
        margin-bottom: 12px;

        &:last-child {
          margin-bottom: 0;
        }

        & > .title {
          font-family: Source Han Sans CN;
          font-weight: bold;
          font-size: 24px;
          color: #28f7ff;
          text-align: center;
        }
      }
    }
  }
}
</style>